import { observer } from 'mobx-react-lite';
import { ComponentType } from 'react';

import { useStores } from 'src/components/common/root-store-provider/root-store-provider';

const withQuizName = <T extends object>(
  Component: ComponentType<{ name: string } & T>,
) =>
  observer((props: T) => {
    const { quizStore } = useStores();
    if (quizStore.name == null) {
      throw new Error('Name step must be completed first');
    }

    return <Component name={quizStore.name} {...props} />;
  });

export default withQuizName;
